
import { z } from "zod";

export const PartnerFlowValues = ["AMERICAN_FAMILY", "AMERICAN_FAMILY_ESTIMATE_ONLY", "AMERICAN_FAMILY_INSURANCE", "ARCASA", "BRANCH_INSURANCE", "BREEZY", "DIRECT_TO_CONSUMER", "DIRECT_TO_CONSUMER_RANGED_QUOTE", "FIELD_SALES", "OPEN_DOOR", "OPENLY", "SUNRUN_POST_PTO_DAMAGE", "SUNRUN_POST_PTO_RNR", "SUNRUN_POST_PTO_WORK_ORDER", "SUNRUN_POST_PTO_WORK_ORDER_ONLY", "SUNRUN_PRE_PTO", "SUNRUN_PRE_PTO_STRATEGIC_PARTNER", "SUNRUN_REMI_WARRANTY", "THUMBTACK", "TRUCOST", "WARRANTY", "WESTHILL", "WESTHILL_MRP", "WESTHILL_STATE_FARM"] as const;
export const PartnerFlowSchema = z.enum(PartnerFlowValues);
export const PartnerFlow = PartnerFlowSchema.enum;
export type PartnerFlow = (typeof PartnerFlowValues)[number];
export const PartnerFlowDisplayNames = { "AMERICAN_FAMILY": "American Family (Xactanalysis)",
"AMERICAN_FAMILY_ESTIMATE_ONLY": "American Family (Estimate Only)",
"AMERICAN_FAMILY_INSURANCE": "American Family (Remi Portal)",
"ARCASA": "Arcasa",
"BRANCH_INSURANCE": "Branch",
"BREEZY": "Breezy",
"DIRECT_TO_CONSUMER": "DTC",
"DIRECT_TO_CONSUMER_RANGED_QUOTE": "DTC Ranged Quote",
"FIELD_SALES": "Field Sales",
"OPEN_DOOR": "OpenDoor",
"OPENLY": "Openly",
"SUNRUN_POST_PTO_DAMAGE": "Sunrun Post-PTO Damage",
"SUNRUN_POST_PTO_RNR": "Sunrun Post-PTO R&R",
"SUNRUN_POST_PTO_WORK_ORDER": "Sunrun Post-PTO PT",
"SUNRUN_POST_PTO_WORK_ORDER_ONLY": "Sunrun Post-PTO WO Only",
"SUNRUN_PRE_PTO": "Sunrun Pre-PTO",
"SUNRUN_PRE_PTO_STRATEGIC_PARTNER": "Sunrun Pre-PTO (Strategic Partner)",
"SUNRUN_REMI_WARRANTY": "Sunrun Remi Warranty",
"THUMBTACK": "Thumbtack",
"TRUCOST": "TruCost",
"WARRANTY": "Warranty",
"WESTHILL": "Westhill (Travelers DRP)",
"WESTHILL_MRP": "Westhill (Travelers MRP)",
"WESTHILL_STATE_FARM": "Westhill (State Farm)", } satisfies Record<PartnerFlow, string>;
